import {getPropertyByPid, getPropertyBySearchString} from 'actions/propertyActions'
import {FAKE_PID} from 'constants/appRoutesConstants'
import {ERROR, LOADED, LOADING} from 'constants/reduxStatuses'
import {useEffect} from 'react'
import {useSelector} from 'react-redux'
import {useHistory, useLocation} from 'react-router-dom'
import {propertyPidSelector, propertyStatusSelector} from 'selectors'
import {useAppDispatch} from 'services/store'

export function usePropertyData(pidInUrl: string) {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const history = useHistory()
  const pid = useSelector(propertyPidSelector)
  const propertyStatus = useSelector(propertyStatusSelector)

  useEffect(() => {
    if (!pidInUrl) {
      // no pid in url means do not need to get property data.
      return
    }

    const isDataChanged = () => (pid ? pidInUrl !== pid : pidInUrl !== FAKE_PID)
    const isError = propertyStatus === ERROR
    const isLoaded = propertyStatus === LOADED
    const isLoading = propertyStatus === LOADING

    // Fetch the property data if it doesn't exist yet or forceUpdate (eg: the pid is different than the one in Redux )
    // AND there is no error (this prevents the page from
    // infinitely making requests in the case the pid does not exist)
    if ((!isLoaded || isDataChanged()) && !isError) {
      if (!isLoading) {
        if (pidInUrl === FAKE_PID) {
          // get property by search
          dispatch(getPropertyBySearchString(location.search)).then(property => {
            if (property?.pid) {
              // update pid in Url
              history.replace({
                pathname: location.pathname.replace(FAKE_PID, property.pid)
              })
            }
          })
        } else {
          // get property by pid
          dispatch(getPropertyByPid(pidInUrl))
        }
      }
    }
  }, [dispatch, location, history, propertyStatus, pid, pidInUrl])
}
